<template>
  <div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('contact_title')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../../assets/imgs/illust-signin-man.png" class="inquryimg"/>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-2"></div>
          <div class="col-md-8">

            <form name="form" @submit.prevent="doContact()">
              <div class="row input eachinquryline" :class="{ invalid: $v.name.$error }">

                <div class="col-md-4">
                  <label class="mplus2p-m spacing1-2 black signlabel">{{$t('ep_name')}} <span
                    style="color: red;">*</span> </label>
                </div>
                <div class="col-md-8">
                  <div class="regselectboxs  form-group" style=" min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           class="form-control login_widget"
                           name="name"
                           v-model="$v.name.$model"
                    />
                    <div class="help-block" v-if="!$v.name.req && nameFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>
              <div class="row input eachinquryline" :class="{ invalid: $v.email.$error }">
                <div class="col-md-4">
                  <label class="mplus2p-m spacing1-2 black signlabel">{{$t('r_email')}} <span
                    style="color: red;">*</span> </label>
                </div>
                <div class="col-md-8">
                  <div class="regselectboxs  form-group" style=" min-width: 415px;">
                    <input style="min-height:50px" placeholder="yourname@example.com"
                           type="email"
                           class="form-control login_widget"
                           name="email"
                           v-model="$v.email.$model"
                    />
                    <div class="help-block" v-if="!$v.email.email">{{$t('r_c_email_validation')}}</div>
                    <div class="help-block" v-if="!$v.email.req && emailFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>
              <div class="row eachinquryline">
                <div class="col-md-4">
                  <label class="mplus2p-m spacing1-2 black signlabel">{{$t('cp_name')}} </label>
                </div>
                <div class="col-md-8">
                  <div class="regselectboxs  form-group" style=" min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           class="form-control login_widget"
                           name="companyName"
                           v-model="companyName"
                    />
                  </div>
                </div>
              </div>
              <div class="row input eachinquryline" :class="{ invalid: $v.message.$error }">
                <div class="col-md-4">
                  <label class="inqurylabel mplus2p-m spacing1-2 black">{{$t('contact_item')}} <span
                    style="color: red;">*</span></label>
                </div>
                <div class="col-md-8 form-group">
                  <textarea :placeholder="$t('unify_test')"
                            class="inqurytextarea form-control"
                            name="contents"
                            v-model="$v.message.$model"> </textarea>
                  <div class="help-block" v-if="!$v.message.req && messageFocus">{{$t('required_filed')}}</div>
                </div>
              </div>
              <div class="row eachinquryline">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                  <button type="submit" class="btn bluebtn submitinqury">{{$t('contact_button')}}</button>
                </div>
                <div class="col-md-2"></div>
              </div>
            </form>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from "vuelidate";
  import {required, email} from "vuelidate/lib/validators";
  import axios from "axios";
  import {EventBus} from "../../../main.js";

  export default {
    mixins: [validationMixin],

    validations: {
      name: {req:required},
      email: {req:required, email},
      message: {req:required}
    },
    data() {
      return {
        model: {},
        name: "",
        email: "",
        companyName: "",
        message: "",
        messageFocus: false,
        emailFocus: false,
        nameFocus: false,

        lan: "jp"
      };
    },
    methods: {
      doContact() {
        const thisVue = this;
        const formData = {
          name: this.name,
          email: this.email,
          company: this.companyName,
          message: this.message
        };
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.nameFocus = true;
          this.emailFocus = true;
          this.messageFocus = true;
          setTimeout(() => {
            $('html, body').animate({scrollTop:$($('.invalid')[0]).position().top+255}, 'slow');
          },1);
        } else {
          axios
          .post("/contact", formData)
          .then(res => {
            if (!res.data.result) {
              for (var i = 0; i < res.data.errors.length; i++) {
                if (res.data.errors[i].field === "name") {
                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "email") {
                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "company") {
                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "message") {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
            } else {
              this.$toaster.success(thisVue.$t("success_contact_us1") + thisVue.$t("success_contact_us2"), {timeout: 5000});
              this.$v.$reset();
              this.name = "";
              this.message = "";
              this.email = "";
              this.companyName = "";
              this.nameFocus = false;
              this.emailFocus = false;
              this.messageFocus = false;

            }
          })
          .catch(err => {
            this.$toaster.error(thisVue.$t("err_network"));
          });
        }
        
      }
    }
  };
</script>

<style scoped>
  .inquryimg {
    margin-top: 60px;
  }

  .inqurylabel {
    font-size: 1rem;
    font-weight: 500;
    margin-top: 15px;
  }

  .inqueryselectbox {
    width: 240px;
    height: 40px;
    border-radius: 6.4px;
    background-color: #ffffff;
    border: solid 1px #e4e4e6;
  }

  .ispanel {
    float: left;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #3d7dd8;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input.invalid textarea {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .inqurytextarea {
    width: 100%;
    height: 240px;
    border-radius: 6.4px;
    background-color: #f0f2f4;
    border: solid 1px #e6e8ea;
  }

  .eachinquryline {
    margin-top: 20px;
  }

  .submitinqury {
    width: 100%;
    height: 56px;
    margin-top: 10px;
  }

  @media screen and (max-width: 768px) {
    .inquryimg {
      margin-top: 0px;
    }
  }

  @media screen and (max-width: 575.98px) {

  }
</style>
